class Settlement {
    date;
    constructor(response) {
        this.date = response.date !== undefined ? new Date(response.date) : undefined;
    }
    toResponse() {
        return {
            date: this.date?.toISOString()
        };
    }
}
export default Settlement;
